var map = {
	"./AI.svg": 20721,
	"./AI_white.svg": 71041,
	"./Cathodic.svg": 6743,
	"./Cathodic_white.svg": 41463,
	"./CoatingAnalyser_active.png": 99161,
	"./CoatingAnalyser_white.png": 26689,
	"./CorrosionAnalyser.svg": 85047,
	"./CorrosionAnalyser_white.svg": 54422,
	"./Delete.svg": 82297,
	"./Document.svg": 74286,
	"./IOWS.svg": 39675,
	"./IOWS_white.svg": 59486,
	"./Location_icon.svg": 44601,
	"./Location_icon_Dark.svg": 39367,
	"./None_Sign.svg": 63787,
	"./Notification.svg": 45805,
	"./Oil_barrel.svg": 72603,
	"./Oil_barrel_Dark.svg": 83956,
	"./RBI.svg": 39388,
	"./RBI_white.svg": 78318,
	"./Simplification_Red.svg": 35868,
	"./Simplification_yellow.svg": 87484,
	"./Task.svg": 73113,
	"./add_event-old.svg": 77198,
	"./add_event.svg": 37976,
	"./calendar.svg": 14525,
	"./document-link.svg": 72469,
	"./document-link_Dark.svg": 37863,
	"./file.svg": 79759,
	"./file_white.svg": 96841,
	"./fluent_column-triple-20-regular.svg": 43008,
	"./history.svg": 52157,
	"./inspection.svg": 99712,
	"./inspection_white.svg": 53609,
	"./notification_sleep.svg": 16082,
	"./office-push-pin.svg": 62223,
	"./sand_clock.svg": 12282,
	"./sand_clock_white.svg": 30780,
	"./solar_ruler-linear.svg": 41538,
	"./solar_ruler-linear_Dark.svg": 40164,
	"./speedometer.svg": 30601,
	"./speedometer_Dark.svg": 56064,
	"./thermometer.svg": 2884,
	"./thermometer_Dark.svg": 84027,
	"./thickness.svg": 95329,
	"./thickness_white.svg": 20335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29284;